import { callImageService } from 'src/modules/imageServiceUploader/utils/fetchAsset';
import { retry } from './retry';

export enum ProcessingStatus {
  PENDING = 'pending',
  FAIL = 'failed',
}

export const UNPROCESSABLE_IMAGE_MESSAGE = 'unprocessable_image_message';
export const PENDING_MESSAGE = 'pending_message';

export interface ImageCheckerArgs {
  id: string;
  childId?: string;
  language?: string;
}

// From usage perspective we want to:
// throw an error when it is likely to recover if retried
// just return an error message if we know retrying won't help
const checkImageReadiness = ({ id, childId }: ImageCheckerArgs) => {
  const imagePath = childId ? `${id}/${childId}` : id;

  return callImageService({ id: imagePath, method: 'GET' })
    .then(async (response): Promise<{ error?: string; ok?: boolean }> => {
      if (!response.ok) {
        throw new Error(PENDING_MESSAGE);
      }

      const { published, status } = await response.json();

      if (published) {
        return { ok: true };
      }

      if (status === ProcessingStatus.FAIL) {
        return { ok: false, error: UNPROCESSABLE_IMAGE_MESSAGE };
      }

      if (status === ProcessingStatus.PENDING) {
        throw new Error(PENDING_MESSAGE);
      }

      throw new Error(UNPROCESSABLE_IMAGE_MESSAGE);
    })
    .catch(() => {
      throw new Error(PENDING_MESSAGE);
    });
};

export default ({ id, childId }: ImageCheckerArgs) =>
  retry(() => checkImageReadiness({ id, childId }), 10, 1000).catch((err) => ({
    error: err.message,
  }));

export { checkImageReadiness as checkImageReadinessForTest };
